import _regeneratorRuntime from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.regexp.replace";
import _objectSpread from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getWarehousePermission } from "@/api/WMS/wmsbase.js";
import { mapGetters, mapState } from "vuex";
// import Breadcrumb from "@/components/Breadcrumb"
// import Hamburger from "@/components/Hamburger"
import Logo from "./Sidebar/Logo";
import ErrorLog from "@/components/ErrorLog";
import Screenfull from "@/components/Screenfull";
// import SizeSelect from "@/components/SizeSelect";
// import Search from "@/components/HeaderSearch"
import avatarDefaultImg from "@/assets/logo/avatar-default.png";
import { getUserInfov2 } from "@/api/user";
import { getAvatar, getPersonName } from "@/utils/auth";
import apps from "./apps/apps";
export default {
  components: {
    // Breadcrumb,
    // Hamburger,
    ErrorLog: ErrorLog,
    Screenfull: Screenfull,
    Logo: Logo,
    apps: apps
    // SizeSelect,
    // Search
  },
  data: function data() {
    return {
      warehouseName: "",
      userName: "",
      avatarImg: "",
      messageDialogVisible: false,
      selectedMessage: null
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapGetters(["sidebar", "avatar", "name", "device"])), mapGetters('message', ['totalUnreadMessages'])), mapState('message', ['recentMessages'])), {}, {
    defaultTheme: function defaultTheme() {
      return this.$store.state.settings.theme;
    },
    greeting: function greeting() {
      var now = new Date();
      var hour = now.getHours();
      if (hour < 6) {
        return "凌晨好！";
      } else if (hour < 9) {
        return "早上好！";
      } else if (hour < 12) {
        return "上午好！";
      } else if (hour < 13) {
        return "中午好！";
      } else if (hour < 17) {
        return "下午好！";
      } else if (hour < 19) {
        return "傍晚好！";
      } else {
        return "晚上好！";
      }
    },
    showLogo: function showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    isCollapse: function isCollapse() {
      return !this.sidebar.opened;
    },
    formattedMessageContent: function formattedMessageContent() {
      if (!this.selectedMessage) return '';
      return this.selectedMessage.messageContent.replace(/\\n/g, '\n').replace(/\\t/g, '\t').replace(/\\r/g, '\r').replace(/\n/g, '<br>').replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;');
    }
  }),
  created: function created() {
    this.getUserInfo();
    this.getWarehouseName();
    // 初始化消息数量
    this.initMessageCounts();
  },
  mounted: function mounted() {
    this.avatarImg = getAvatar('avatar');
    this.userName = getPersonName('personName');
  },
  methods: {
    // 初始化消息数量
    initMessageCounts: function initMessageCounts() {
      this.$store.dispatch('message/initMessageCounts');
      this.$store.dispatch('message/startMessageTimer');
    },
    getUserInfo: function getUserInfo() {
      var _this = this;
      getUserInfov2().then(function (res) {
        if (res.success) {
          var Data = res.response;
          _this.avatarImg = Data.avatar;
        }
      });
    },
    getWarehouseName: function getWarehouseName() {
      var _this2 = this;
      getWarehousePermission().then(function (res) {
        if (res.code === 200) {
          for (var key in res.data.maps) {
            if (res.data.warehouseCode === key) {
              _this2.warehouseName = res.data.maps[key];
            }
          }
        }
      });
    },
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    // 导航到首页
    goToHomePage: function goToHomePage() {
      this.$router.push('/');
    },
    // 处理消息点击
    handleMessageCommand: function handleMessageCommand(message) {
      // 打开消息对话框
      this.selectedMessage = message;
      this.messageDialogVisible = true;

      // 如果消息未读，则标记为已读
      if (message.status === 0) {
        this.$store.dispatch('message/markMessageAsRead', message.messageKey);

        // 手动更新消息状态，这样用户界面会立即反映变化
        var messageType = message.type;
        var tabName = this.getTabNameByType(messageType);
        if (tabName) {
          // 更新本地消息数量
          var currentCounts = _objectSpread({}, this.$store.state.message.localMessageCounts);
          if (currentCounts[tabName] && currentCounts[tabName] > 0) {
            currentCounts[tabName] -= 1;
            this.$store.commit('message/SET_MESSAGE_COUNTS', currentCounts);
          }
        }
      }
    },
    // 根据消息类型获取对应的标签名
    getTabNameByType: function getTabNameByType(type) {
      var typeToTabMap = {
        '1': 'finance',
        // 财务消息
        '2': 'stock',
        // 库存消息
        '4': 'system' // 系统消息
      };

      return typeToTabMap[type] || null;
    },
    logout: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return this.$store.dispatch('message/stopMessageTimer');
            case 3:
              _context.next = 5;
              return this.$store.dispatch('message/resetMessageState');
            case 5:
              _context.next = 7;
              return this.$store.dispatch('user/logout');
            case 7:
              if (process.env.NODE_ENV === "production") {
                location.href = process.env.VUE_APP_APP_HOST;
              } else {
                this.$router.push("/login?redirect=/");
              }
              _context.next = 13;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);
              console.error('登出失败:', _context.t0);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 10]]);
      }));
      function logout() {
        return _logout.apply(this, arguments);
      }
      return logout;
    }(),
    imageLoadOnError: function imageLoadOnError(e) {
      e.target.src = avatarDefaultImg;
    },
    jumpPersonalCenterPage: function jumpPersonalCenterPage() {
      this.$router.push({
        path: '/wms/releaseManagement/personalCenter'
      });
    }
  }
};